import React from "react"
import LoadingSpinner from "components/loading-spinner"
import ReactPlayer from "react-player"
import { BsChevronDown } from "react-icons/bs";

import {
	ActionButton,
} from "./index"

import {
	updateTagApi,
} from "services/api-helpers"

import {
	getQueryParam,
	addQueryParams,
} from "services/functions"

import {
	FB_PIXEL_TRACK_EVENT_VIEW,
	FB_PIXEL_EVENT_OPENED_URL,
	FB_PIXEL_EVENT_PRESSED_PLAY,
	FB_PIXEL_EVENT_WATCHED_25,
	FB_PIXEL_EVENT_WATCHED_50,
	FB_PIXEL_EVENT_WATCHED_75,
	FB_PIXEL_EVENT_WATCHED_85,
	FB_PIXEL_EVENT_WATCHED_100,
	EVENTS_MAPPING,
} from "./constants"

export default class Webinar extends React.Component {

	eventsTracked = []
	muid = null
	lid = null
	redirectTimeout = 150

	state = {
		loaded: false,
	}

	componentDidMount() {
		this.muid = getQueryParam("muid")
		this.lid = getQueryParam("lid")
		this.page = this.props.data.url

		this._initFBQ();
		this._trackFBQ(FB_PIXEL_TRACK_EVENT_VIEW, "track")
	}

	_handleEventsTrack = (event) => {
		this.eventsTracked.push(event)
		this._handleUpdateEventMcTag(event)
	}

	_handleUpdateEventMcTag = (event) => {

		if(!this.muid && !this.lid) {
			return
		}

		const event_name = EVENTS_MAPPING[event]
		if(typeof event_name === "undefined") {
			return
		}

		const {muid, lid, page} = this
		const {origin, pathname} = window.location
		this._updateTag({
			event_name,
			manychat_user_id: muid,
			lead_id: lid,
			registration_host: `${origin}${pathname}`,
			page,
		})

		this._log(`updated MC tag: ${event_name}`)
	}

	_updateTag = (data) => {
		updateTagApi(data)
	}

	// FB PIXEL
	_hasFbPixelId = () => {
		return typeof window.fbq !== "undefined" && !!this.props.fbPixelId
	}

	_initFBQ = () => {
		if(!this._hasFbPixelId()) {
			return
		}

		window.fbq("init", this.props.fbPixelId)
		this._log(`init fbq: ${this.props.fbPixelId}`)
	}

	_trackFBQ = (event, action) => {
		if(!this._hasFbPixelId()) {
			return
		}
		
		const {pixelEventPrefix} = this.props.data
		const eventName = (typeof pixelEventPrefix !== "undefined")
		? `${pixelEventPrefix} - ${event}`
		: event
		window.fbq(action || "track", eventName)
		this._log(`${action}: ${eventName}`)
	}

	// GTAG
	_hasGtagIds = () => {
		return typeof window.gtag !== "undefined" && !!this.props.gtagId && !!this.props.gtagCampaignId
	}

	_initGTAG = () => {
		if(!this._hasGtagIds()) {
			return
		}

		window.gtag('js', new Date())
		window.gtag('config', this.props.gtagId)
	}

	_trackGtagEvent = (event) => {
		if(!this._hasGtagIds()) {
			return
		}

		window.gtag('event', 'conversion', {'send_to': `${this.props.gtagId}/${this.props.gtagCampaignId}`})
		this._log(`tracked gtag conversion: ${event}`)
	}

	_log = (msg) => {
		if(this.props.verbose && typeof console !== "undefined") {
			console.log(msg)
		}
	}

	// _trackSklikConversion = () => {
	// 	const event = "sklikConversion"
	// 	if(this.eventsTracked.indexOf(event) !== -1) {
	// 		return
	// 	}

	// 	this.eventsTracked.push(event)
	// 	this.setState({
	// 		sklikConversion: true,
	// 	})
	// }

	_handlePageAction = () => {
		const {data} = this.props
		if(typeof data.action === "undefined") {
			return
		}

		const {
			url,
			redirectAfterWatch,
			queryParams,
		} = data.action
		if(url && redirectAfterWatch) {
			window.location.href = url + addQueryParams(queryParams)
		}
	}

  _handleTrackEvent = (event) => {

  	if(this.eventsTracked.indexOf(event) !== -1) {
  		return
  	}

  	this._handleEventsTrack(event)

  	switch(event) {
  		case FB_PIXEL_EVENT_PRESSED_PLAY:
  			this._trackFBQ(event, "trackCustom")
  		break

  		case FB_PIXEL_EVENT_WATCHED_85:
  			this._trackFBQ(event, "trackCustom")
				this._trackGtagEvent("gtagConversion")
				// this._trackSklikConversion()
  		break

  		case FB_PIXEL_EVENT_WATCHED_100:
  			setTimeout(this._handlePageAction, this.redirectTimeout);
  		break;

  		default:
  		break
  	}
  	
  }

	_handleOnProgress = ({played}) => {

		const playedPercent = Math.round(played * 10000) / 100;
		if(playedPercent >= 100) {
			this._handleTrackEvent(FB_PIXEL_EVENT_WATCHED_100);
			return
		}

		if(playedPercent >= 85) {
			this._handleTrackEvent(FB_PIXEL_EVENT_WATCHED_85)
			return
		}

		if(playedPercent >= 75) {
			this._handleTrackEvent(FB_PIXEL_EVENT_WATCHED_75)
			return
		}

		if(playedPercent >= 50) {
			this._handleTrackEvent(FB_PIXEL_EVENT_WATCHED_50)
			return
		}

		if(playedPercent >= 25) {
			this._handleTrackEvent(FB_PIXEL_EVENT_WATCHED_25)
			return
		}

  }

  _handleOnReady = el => {
  	setTimeout(() => this.setState({loaded: true}), 300)
  	this._handleTrackEvent(FB_PIXEL_EVENT_OPENED_URL);
  }

  scrollToPlayer = () => {
  	this.refs.playerWrapper.scrollIntoView({
  		behavior: 'smooth'
  	});
  }

	render() {

		const {data} = this.props
		if(!data) {
			return false
		}

		return (
			<React.Fragment>

				<div className="app-body">
					<div className="container">
						<h1 className="heading">{data.headline}</h1>

						<ActionButton onClick={() => {
							this.refs.playerWrapper.scrollIntoView({
					  		behavior: 'smooth'
					  	});
						}} text={data.watchWebinar}/>

						{!!data.watchWebinarActionHtml && (
							<div dangerouslySetInnerHTML={{__html: data.watchWebinarActionHtml}}></div>
						)}

						<div className="padded">
							<BsChevronDown size="1.5rem" cursor="pointer" onClick={() => {
								this.refs.playerSection.scrollIntoView({
						  		behavior: 'smooth'
						  	});
							}} />
						</div>

					</div>
					<div ref="playerSection" className="bg-black">
						<div className="container">

							<div ref="playerWrapper" className="padded">

								<div className="player-wrapper">
									<ReactPlayer
										className={"react-player" + (this.state.loaded ? " in" : "")}
					          width="100%"
					          height="100%"
										url={this.props.videoSrc}
										controls
										onReady={this._handleOnReady}
										onStart={start => {
											this._handleTrackEvent(FB_PIXEL_EVENT_PRESSED_PLAY)
										}}
										onProgress={this._handleOnProgress}/>
									<div className={"loading-spinner" + (!this.state.loaded ? " in" : "")}>
										<LoadingSpinner />
									</div>
								</div>
							</div>

							{data.action && (
								<div className="main-action">
									<ActionButton {...data.action} />
								</div>
							)}
						</div>

						<div className="container">
							{!!data.numbers && !!data.numbers.length && data.numbers.map(({number, text, className, url}) => (
								<div className="col col-4">
									<div className={"number" + (typeof className !== "undefined" ? " " + className : "")}>
										<div className="number-icon">
											{typeof url !== "undefined" && (
												<a href={url} target="_blank" rel="noopener noreferrer">{number}</a>
											)}
											{typeof url === "undefined" && number}
											
										</div>
										<div className="number-text">
											{text}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>

					
				</div>
			</React.Fragment>
		)
	}
}
